import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { copy } from "shared/assets";
import { User } from "shared/assets/icons";
import { Card, Loader } from "shared/components";
import { BAND_ACTIONS, EventUniqueBlocks, IVenueBlock } from "Bands/types";
import { dataMetaSelector, eventBlockSelectorCreator } from "Bands/state";
import { VenueBlockForm } from "Bands/containers";
import { useClearActionMetaOnUnMount, useEventRoute } from "Bands/utils";
import { addTemporaryToast } from "shared/components/Toast";
import { IAPIState, IStatus } from "shared/types";
import { BAND_PATHS } from "Bands/router";
import { mapUserPermissions } from "shared/utils";
import { FourOhThree } from "shared/pages";

const { venueBlock: venueBlockCopy } = copy;

export const EditEventVenueBlockPage = () => {
  const dispatch = useDispatch();
  const { pushRoute } = useEventRoute();
  let { blockId } = useParams<{ blockId: string }>();

  const venueBlockSelector = eventBlockSelectorCreator(
    blockId,
    EventUniqueBlocks.venue
  );
  const venueBlock = useSelector(venueBlockSelector) as IVenueBlock;

  const { api: apiMeta } = useSelector(
    dataMetaSelector(BAND_ACTIONS.editEventVenueBlock)
  );
  useClearActionMetaOnUnMount(BAND_ACTIONS.editEventVenueBlock);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: venueBlockCopy.messages.edited,
        })
      );

      pushRoute(BAND_PATHS.BAND_EVENT, { hash: blockId });
    }
  }, [apiMeta?.status, blockId, dispatch, pushRoute]);

  if (!venueBlock) return <Loader />; // fetching

  if (venueBlock && !mapUserPermissions(venueBlock.permissions || []).EDIT) {
    return <FourOhThree />;
  }

  return (
    <Card
      title={venueBlockCopy.edit.title.replace(
        "%s",
        venueBlock?.title || "..."
      )}
      icon={User}
    >
      <VenueBlockForm
        type="edit"
        blockId={venueBlock.id}
        title={venueBlock.title}
        venueId={venueBlock.venue.id}
        stageId={venueBlock.stage?.id}
        capacityId={venueBlock.stageCapacity?.id}
      />
    </Card>
  );
};
